import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "programmeOverview/:insightType",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "planning-insights" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
